/**
 *
 * Asynchronously loads the component for GenerateDocFromLink
 *
 */

import { lazyLoad } from 'utils/loadable';

export const GenerateDocFromLink = lazyLoad(
  () => import('./index'),
  module => module.GenerateDocFromLink,
);
